import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReportingInstructions } from '../models/report.model';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportingInstructionsService {
  endpoint = environment.apiEndpoint + '/ReportingInstructions/';
  constructor(private httpClient: HttpClient,
              private http: HttpClient) { }
  // constructor(private http: HttpClient) {}

  getReportingInstructionsByType(type: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportingInstructionsByType?Type=' + type);
  }

  getReportingInstructionsById(id: string): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportingInstructionsById?Id=' + id);
  }

  getReportingInstructionsByParentId(parentId: string): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportingInstructionsByParentId?ParentId=' + parentId);
  }

  addReportingInstructions(reportInstrutions: any): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportInstrutions;
    return this.http.post(environment.apiEndpoint + '/ReportingInstructions/CreateFolderUploadDocuments', body, {
      headers,
      observe: 'response'
    });
  }

  updateDocument(reportInstrutions: any): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = reportInstrutions;
    return this.http.post(environment.apiEndpoint + '/ReportingInstructions/UpdateDocument', body, {
      headers,
      observe: 'response'
    });
  }
  
  //downloadDocument$(documentId:any,fileType: string):Observable<any>
  downloadDocument$(documentId:any,fileType: string):void
  {
    //  return this.httpClient.get(this.endpoint+"GetDocument?id="+documentId,{responseType:'blob'}).pipe(map((resp:Blob)=>{
    //   return new Blob([resp], { type: 'application/' + fileType });
    //  }));
    window.open(this.endpoint+"GetDocument?id="+documentId);
  }

  deleteDocument(Id: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = Id;
    return this.http.post(environment.apiEndpoint + '/ReportingInstructions/DeleteDocument?Id=' + Id, body, {
      headers,
      observe: 'response'
    });
  }

}
